import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop — Resets scroll position to (0,0) on every route change.
 *
 * Fixes the SPA quirk where React Router preserves scroll position between
 * page navigations. Users clicking "Membership" from the footer expected the
 * Contact page to open at the top, not mid-way down where the footer sat.
 */
export default function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }, [pathname]);

    return null;
}
